export default "__VITE_ASSET__DiH$30l$__"